import { ROUND_SELECT } from '../actions/round';
import { HEAT_SELECT } from '../actions/heat';
import {
    POPUP_SHOW,
    POPUP_HIDE,
    POPUP_SET_REF,
    POPUP_UNSET_REF,
    POPUP_POSITION,
    POPUP_UNSET_PARENT_REF,
    POPUP_REPOSITION
} from '../actions/popup';

const defaultState = {
    ref: null,
    parentRef: null,
    show: false,
    id: null,
    top: 0,
    left: 0
};

const reposition = (ref, parentRef) => {
    if (!ref || !parentRef) {
        return;
    }

    const {
        x,
        y
    } = parentRef.getBoundingClientRect();

    const { scrollTop } = document.documentElement;

    ref.style.left = `${
        x
        + parentRef.clientWidth / 2
        + ref.clientWidth / 2
        - ref.clientWidth
    }px`;

    ref.style.top = `${
        y
        + scrollTop
        - ref.clientHeight
        - 5
    }px`;
};

export default (state = defaultState, { type, payload = {} }) => {
    switch (type) {
        case POPUP_SET_REF: {
            return {
                ...state,
                parentRef: null,
                ref: payload
            };
        }

        case POPUP_UNSET_REF: {
            return {
                ...state,
                id: null,
                parentRef: null,
                ref: null
            };
        }

        case POPUP_UNSET_PARENT_REF: {
            return {
                ...state,
                parentRef: null
            }
        }

        case POPUP_SHOW: {
            return {
                ...state,
                id: payload,
                show: true
            };
        }

        case POPUP_HIDE:
        case ROUND_SELECT:
        case HEAT_SELECT: {
            return {
                ...state,
                id: null,
                parentRef: null,
                show: false
            };
        }

        case POPUP_POSITION: {
            const { ref } = state;
            const parentRef = payload;

            reposition(
                ref,
                parentRef
            );

            return {
                ...state,
                parentRef
            };
        }

        case POPUP_REPOSITION: {
            const { ref, parentRef } = state;

            reposition(
                ref,
                parentRef
            );

            return state;
        }

        default: {
            return state;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/popup.js